import { useQuery } from "@tanstack/react-query";
import type { ForecastRunTransactionResponseApi } from "../api/models/forecastRun";
import { getForecastRunTransactions } from "../api/services/forecastService";

export function useForecastRunTransactions(
  runId: number | undefined,
  fromDate?: string,
  toDate?: string,
  enabled = true,
) {
  return useQuery<ForecastRunTransactionResponseApi[]>({
    queryKey: ["forecast-run-transactions", runId, fromDate, toDate],
    queryFn: () => getForecastRunTransactions(runId!, fromDate, toDate),
    enabled: enabled && runId != null,
    staleTime: 30 * 60 * 1000,
  });
}
